/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NotPlannedOrderApiModel } from './notPlannedOrderApiModel';


export interface PageDataApiModelOfNotPlannedOrderApiModel { 
    currentPage: number;
    perPage: number;
    totalCount: number;
    totalPages: number;
    items: Array<NotPlannedOrderApiModel>;
}

